/**
 * Ідентифікатор у маршруті сторінки нового (ще не збереженого) запису: /:group/:module/<сутність>/new — повна форма в режимі редагування з типовими
 * значеннями; «Зберегти» створює запис і відкриває його сторінку.
 */
export const NEW_RECORD_ID = 'new';
